import { Component, Input, OnDestroy, ViewEncapsulation } from '@angular/core';

import { Subject, Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

import { TachoService } from '@commons/services/tacho/tacho.service';
import { DriverService } from '@commons/services/driver/driver.service';
import { MappingService } from '../../../../../commons/services/mapping/mapping.service';
import { TachoTypeData } from '@src/app/enum/tacho.enum';
import { StatusTimeFormatPipe } from '@commons/pipes/status-time-format.pipe';
import { prepareTachoDataToDisplay } from '@src/app/utils/tacho-fncs';

@Component({
    selector: 'tk-vehicle-details-tacho-tab',
    styleUrls: ['./vehicle-details-tacho-tab.component.less'],
    templateUrl: './vehicle-details-tacho-tab.component.html',
    encapsulation: ViewEncapsulation.None,
    providers: [StatusTimeFormatPipe],
})
export class VehicleDetailsTachoTabComponent implements OnDestroy {

    public sectionDataActiveSlot: any = {};
    public isLoadingData: boolean = true;
    public readonly TACHO_TYPE_DATA = TachoTypeData;

    // ------------Jazda------------
    // 4.5h ------------------------------------------------------------------------------
    private cName_45h = 'Jazda 4:30 h';
    private cDesc_45h = 'Informuje nas o tym, że kierowca jedzie przez ten\nczas, maksymalnie nieprzerwanie \nmoże jechać przez 04:30';
    private ccMax_45h = 4 * 60 * 60 + 30 * 60;  // 4.5h
    // max9PerDay----------------------------------------------------------------------------
    private cName_DayMax9h = 'Jazda dzienna (max 9h)';
    private cDesc_DayMax9h =
        'Informacja ile w danym dniu kierowca jeździł, maksymalny czas jazdy to 9 godzin.\nDzień definiujemy pomiędzy dwoma odpoczynkami od ostatniego odpoczynku dziennego lub tygodniowego';
    private ccMax_DayMax9h = 9 * 60 * 60; // 9h
    // max10PerDay--------------------------------------------------------------------------------
    private cName_DayMax10h = 'Jazda dzienna (max 10h)';
    private cDesc_DayMax10h =
        'Informacja ile w danym dniu kierowca jeździł, maksymalny czas jazdy to 10 godzin. Dzień definiujemy pomiędzy dwoma odpoczynkami od ostatniego odpoczynku dziennego lub tygodniowego';
    private ccMax_DayMax10h = 10 * 60 * 60;  // 10h
    // DaysOver9h-------------------------------------------------------------------------
    private cName_DaysOver9h = 'Powyżej 9h (max 2 dni)';
    private cDesc_DaysOver9h =
        'Informacja ile dni w tygodniu kierowca jechał więcej niż 9h, dopuszczalna wartość to 2 dni jazdy po 10h. Każda przekroczone 9h nawet o 1 min to jest jazda do 10h. W tygodniu od pn 00:00 do nd 23:59';
    private ccMax_DaysOver9h = 2;
    // 2Weeks------------------------------------------------------------------------------
    private cName_2Weeks = 'Dwa tygodnie (max 90h)';
    private cDesc_2Weeks = 'Informacja ile było jazdy przez dwa ostatnie tygodnie, maksymalnie jest to 90h jazdy przez dwa tygodnie.';
    private ccMax_2Weeks = 90 * 60 * 60; // 90h




    // ------------Praca------------

    // work_6h-------------------------------------------------------------------------
    private cName_Work6h = 'Praca ciągła (max 6h)';
    private cDesc_Work6h = 'Informacja o pracy ciągłej bez odpoczynku.\nJazda + praca nie mogą trwać dłużej niż 6h';
    private cMax_Work6h = 6 * 60 * 60; // 6h
    // work_13h-------------------------------------------------------------------------
    private cName_Work13h = 'Praca dzisiaj (max 13h)';
    private cDesc_Work13h = 'Informacja o pracy dziennej.\nJazda + praca + odpoczynek nie mogą trwać dłużej niż 13h';
    private cMax_Work13h = 13 * 60 * 60; // 13h
    // work_15h-------------------------------------------------------------------------
    private cName_Work15h = 'Praca dzisiaj (max 15h)';
    private cDesc_Work15h = 'Informacja o pracy dziennej.\nJazda + praca + odpoczynek + dyspozycyjność nie mogą trwać dłużej niż 15h';
    private cMax_Work15h = 15 * 60 * 60; // 15h
    // WorkInWeek-------------------------------------------------------------------------
    private cName_WorkInWeek = 'Tygodniowy czas pracy (max 144h)';
    private cDesc_WorkInWeek = 'Łączny czas pracy kierowcy liczony od momentu zakończenia ostatniego odpoczynku tygodniowego';
    private cMax_WorkInWeek = 144 * 60 * 60; // 144h


    // ------------Odpoczynek------------

    // Rest45-------------------------------------------------------------------------
    private cName_Rest45 = 'Przerwa 45 min';
    private cDesc_Rest45 = 'Przerwa 45 min wymagana do wyzerowania czasu jazdy ciągłej. Mimimalny czas przerwy dzielonej to 15 min';
    private cMax_Rest45 = 45 * 60; // 45min
    // rest_9hToday-------------------------------------------------------------------------
    private cName_Rest9hToday = 'Odpoczynek dzienny (min 9h)';
    private cDesc_Rest9hToday =
        'Informacja ile godzin w danym cyklu dobowym zostało\npoświęcone na odpoczynek dzienny. Zapisujemy powyżej 3h';
    // Informacja ile godzin w danym cyklu dobowym zostało poświęcone na odpoczynek (sen)
    private cMax_Rest9hToday = 9 * 60 * 60; // 9h
    // rest_9hYesterday-------------------------------------------------------------------------
    private cName_Rest11hToday = 'Odpoczynek dobowy (min 11h)';
    private cDesc_Rest11hToday =
        'Informacja ile godzin w danym cyklu dobowym zostało poświęconych na odpoczynek dzienny. Zapisujemy powyżej 3h';
    private cMax_Rest11hToday = 11 * 60 * 60; // 9h
    // rest_Week-------------------------------------------------------------------------
    private cName_RestWeek = 'Ile odp. 9h w tygodniu (max 3x)';
    private cDesc_RestWeek =
        'Informacja ile razy kierowca wykorzystał skrócony odpoczynek 9h. Max 3 razy pomiędzy odpoczynkami tygodniowymi.';
    private cMax_RestWeek = 3; // 3dni
    // rest_PrevWeek-------------------------------------------------------------------------
    private cName_RestPrevWeek = 'Odp. tygodniowy (24-45h)';
    private cDesc_RestPrevWeek = 'Czas ostatniego odpoczynku tygodniowego';
    private cMax_RestPrevWeek = 24 * 60 * 60; // 24h
    // rest_2Weeks-------------------------------------------------------------------------
    private cName_Rest2Weeks = 'Poprz. odp. tygodniowy (24-45h)';
    private cDesc_Rest2Weeks = 'Czas poprzedniego odpoczynku tygodniowego';
    private cMax_Rest2Weeks = 24 * 60 * 60; // 24h

    /**
     *
     */
    @Input('item') public set setItemData(data: any) {
        if (data?.TC) {
            data.Tacho && this.tachoChangeSubject.next(data);
            this._item = data;
            return;
        }
        this.isLoadingData = false;
    }

    @Input() public hideDriverInfo = false;

    /**
     *
     */
    public slots: any[] = [];
    public _item: any;

    /**
     *
     */
    public activeSlot: any;

    /**
    * Subject for pushing vehicle value changes
    */
    public tachoChangeSubject: Subject<any> = new Subject<any>();

    /**
     * Subscription of stream of tacho slots
     */
    public slotsSub: Subscription;

    public activeSlotIdx?: number = 0;

    public setActiveSlot(idx: number) {
        this.activeSlotIdx = idx;
        this.activeSlot = this.slots[this.activeSlotIdx];
        if (this.activeSlot) {
            const data = prepareTachoDataToDisplay(this.activeSlot, this.translate, this.statusTimeFormatPipe);
            this.sectionDataActiveSlot = data;
        }
    }

    /**
     *
     */
    constructor(
        private $tacho: TachoService,
        private $driver: DriverService,
        private translate: TranslateService,
        private statusTimeFormatPipe: StatusTimeFormatPipe
    ) {
        this.slotsSub = this.tachoChangeSubject
            .subscribe(result => {
                this.slots = [];
                if (result.Tacho) {
                    // slot 1
                    if (result.Tacho.S1 && result.Tacho.S1.Id) {
                        const s = result.Tacho.S1;
                        const slot = this.getSlotData(s);
                        slot.Number = '1';
                        this.slots.push(slot);

                    }
                    // slot 2
                    if (result.Tacho.S2 && result.Tacho.S2.Id) {
                        const s = result.Tacho.S2;
                        const slot = this.getSlotData(s);
                        slot.Number = '2';
                        this.slots.push(slot);
                    }

                    this.isLoadingData = false;
                }

                // jezeli slot aktywny
                if (this.activeSlotIdx || this.activeSlotIdx === 0) {
                    this.setActiveSlot(this.activeSlotIdx);
                    return;
                }
                if (!this.activeSlotIdx && this.slots.length > 0) {
                    this.setActiveSlot(0);
                }
            });
    }


    private getSlotData(s: any) {

        const state = MappingService.convertTachoStatus(s.St);

        const r = {
            Number: '',
            Card: '' + s.Id,
            CurrentState: state,
            StatValue1: s.DD,
            StatValue2: s.DW,
            StatValue3: s.DR,
            StatValue4: s.DRd,

            StartDay: s.SD,
            Recommended_Rest9h: s.RR9,
            Recommended_Rest11h: s.RR11,

            Drive: {

                Act_2Weeks: s.A2W,
                Act_45h: s.A45,
                Act_DayMax10h: s.AM10,
                Act_DayMax9h: s.AM9,
                Act_DaysInWeek: s.ADW,
                Act_DaysOver9h: s.AO9,

                Act_2Weeks_Rest: this.ccMax_2Weeks - s.A2W,
                Act_45h_Rest: this.ccMax_45h - s.A45,
                Act_DayMax10h_Rest: this.ccMax_DayMax10h - s.AM10,
                Act_DayMax9h_Rest: this.ccMax_DayMax9h - s.AM9,
                Act_DaysInWeek_Rest: null,
                Act_DaysOver9h_Rest: this.ccMax_DaysOver9h - s.AO9,


                Max_Act_2Weeks: '90 h',
                Max_Act_45h: '-',
                Max_Act_DayMax10h: '10 h',
                Max_Act_DayMax9h: '9 h',
                // Max_Act_DaysInWeek: '6 dni',
                Max_Act_DaysOver9h: '2 dni'
            },
            Work: {


                Work_6h: s.W6,
                Work_13h: s.W13,
                Work_15h: s.W15,
                Work_Weekly: s.WW,

                Work_6h_Rest: this.cMax_Work6h - s.W6,
                Work_13h_Rest: this.cMax_Work13h - s.W13,
                Work_15h_Rest: this.cMax_Work15h - s.W15,
                Work_Weekly_Rest: this.cMax_WorkInWeek - s.WW,


                Max_Work_6h: '6 h',
                Max_Work_13h: '13 h',
                Max_Work_15h: '15 h',
                Max_Work_Weekly: '3 dni',
            },
            Rest: {
                Rest_11hToday: s.R11,
                Rest_2Weeks: s.R2W,
                Rest_45min: s.R45,
                Rest_9hToday: s.R9,
                Rest_PrevWeek: s.RP,
                Rest_Week: s.RW,

                Rest_11hToday_Rest: this.cMax_Rest11hToday - s.R11,
                Rest_2Weeks_Rest: this.cMax_Rest2Weeks - s.R2W,
                Rest_45min_Rest: this.cMax_Rest45 - s.R45,
                Rest_9hToday_Rest: this.cMax_Rest9hToday - s.R9,
                Rest_PrevWeek_Rest: this.cMax_RestPrevWeek - s.RP,
                Rest_Week_Rest: this.cMax_RestWeek - s.RW,

                Max_Rest_11hToday: '11 h',
                Max_Rest_2Weeks: '24-45 h',
                Max_Rest_45min: '-',
                Max_Rest_9hToday: '9 h',
                Max_Rest_PrevWeek: '24-45 h',
                Max_Rest_Week: '3 dni'
            }
        };


        return r;
    }

    public ngOnDestroy(): void {
        if (this.slotsSub) {
            this.slotsSub.unsubscribe();
        }
    }
}
